module.exports = __webpack_public_path__ + "img/mail-icon-compleet.4bce57d3c5aad11f607c05e109c32aca.svg";